import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const UploadExcel = React.lazy(() => import('.'));

export const uploadExcelRoutes = [
  new Route({
    path: 'upload-excel',
    element: UploadExcel,
    children: [],
  }),
];
